angular.module('bb.util').component('bbModals', {
  transclude: true,
  controller: ModalsController,
  controllerAs: 'vm',
  // Because of the way that bootstrap templates work. You cannot pass in any attributes to the modal.
  // pass in items through the service instead.
  template: /* html */ `
        <div>
            <network-modal/>
            <preview-modal/>
            <appointment-modal />
            <bb-appointment-filter-modal />
            <appointment-config-modal />
            <listing-asset-modal
              ng-if="vm.assetModal.open"
              index="vm.assetModal.index"
              assets="vm.assetModal.assets"/>
            <multi-conf-modal />
            <bb-question-edit-modal />
            <offer-modal />
            <bb-folder-modal />
            <bb-video-player-modal />
            <bb-add-video-modal />
            <bb-user-action-modal />
        </div>`,
});

ModalsController.$inject = ['ModalService'];
function ModalsController(ModalService) {
  const vm = this;

  vm.$onInit = () => {
    vm.assetModal = ModalService.assetModal;
  };
}

export {};
